
import { computed, defineComponent, onMounted, ref, watch } from 'vue'

export default defineComponent({
  name: 'AdobePDFViewer',
  props: {
    adobeClientId: {
      type: String,
      required: true
    },
    showPDF: {
      type: Boolean,
      required: true,
      default: false
    },
    pdfUrl: {
      type: String
    },
    fileName: {
      type: String
    }
  },
  setup(props) {
    const adobeReady = ref(false)
    const adobe = ref(null)
    const viewer = ref(null)

    const shouldPreview = computed(() => {
      return props.showPDF
    })

    const canPreview = computed(() => {
      return adobeReady.value
    })

    const compoundProperty = computed(() => {
      // https://github.com/vuejs/vue/issues/844#issuecomment-271133777
      // reference the reactive properties
      canPreview.value
      shouldPreview.value
      props.pdfUrl
      props.fileName

      return Date.now()
    })

    watch(
      () => compoundProperty.value,
      () => {
        if (canPreview.value && shouldPreview.value && props.pdfUrl && props.fileName) {
          preview()
        }
      }
    )

    onMounted(() => {
      const adobeLib = 'https://acrobatservices.adobe.com/view-sdk/viewer.js'

      if (!scriptPresent(adobeLib)) {
        const adobeEmbedSDK = document.createElement('script')
        adobeEmbedSDK.setAttribute('src', adobeLib)
        document.head.appendChild(adobeEmbedSDK)
      }
      if ((window as any).AdobeDC) {
        initSDK()
      } else {
        document.addEventListener('adobe_dc_view_sdk.ready', initSDK)
      }
    })

    function scriptPresent(script: string): boolean {
      return document.querySelectorAll(`script[src='${script}']`).length > 0
    }

    function initSDK() {
      adobeReady.value = true
      adobe.value = (window as any).AdobeDC
    }

    function getViewer() {
      if (adobe.value) {
        return new (adobe.value as any).View({
          clientId: props.adobeClientId,
          divId: 'viewer'
        })
      }
    }

    async function preview() {
      viewer.value = getViewer()
      if (viewer.value) {
        await (viewer.value as any).previewFile(
          {
            content: { location: { url: props.pdfUrl || '' } },
            metaData: { fileName: props.fileName || '', hasReadOnlyAccess: true }
          },
          { showAnnotationTools: false }
        )
      }
    }
  }
})
